var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import axiosRetry from 'axios-retry';
import get from 'lodash/get';
import { captureException } from 'conversional-exceptions';
axios.defaults.timeout = 50000;
axios.defaults.params = {};
axiosRetry(axios, {
    retries: 3,
    retryDelay: axiosRetry.exponentialDelay,
    retryCondition: function (error) {
        return (axiosRetry.isNetworkOrIdempotentRequestError(error) ||
            (axiosRetry.isIdempotentRequestError(error) && error.code === 'ECONNABORTED'));
    }
});
//isIdempotentRequest && error.code = ...
var API = /** @class */ (function () {
    function API(journeyId, apiKey, domain, version, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.token, token = _c === void 0 ? '' : _c, _d = _b.abTest, abTest = _d === void 0 ? '' : _d;
        var _this = this;
        this.makeUrl = function (path) {
            var basePath = path.startsWith("http") ? path : "".concat(_this.baseUrl).concat(path);
            return basePath
                .replace(/:apiKey/g, _this.apiKey)
                .replace(/:token/g, _this.token)
                .replace(/:journeyId/g, _this.journeyId);
        };
        if (!journeyId) {
            throw new Error('Missing journey id');
        }
        if (!apiKey) {
            throw new Error('Missing api key');
        }
        if (!domain) {
            throw new Error('Missing api domain');
        }
        if (!version) {
            throw new Error('Missing api version');
        }
        this.abTest = abTest;
        this.apiKey = apiKey;
        this.baseUrl = "".concat(decodeURIComponent(domain)).concat(version);
        this.domain = domain;
        this.journeyId = journeyId;
        this.token = token;
        this.version = version;
    }
    API.prototype.request = function (_a) {
        return __awaiter(this, arguments, Promise, function (_b) {
            var response, url, params, _c, responseData, keys, error_1, errorMessage, isErrorString;
            var _d = _b.method, method = _d === void 0 ? 'GET' : _d, path = _b.path, payload = _b.payload, _e = _b.query, query = _e === void 0 ? {} : _e, _f = _b.headers, headers = _f === void 0 ? {} : _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        url = this.makeUrl(path);
                        params = __assign(__assign({}, query), { token: this.token, abTest: this.abTest, apiKey: this.apiKey });
                        _g.label = 1;
                    case 1:
                        _g.trys.push([1, 14, , 15]);
                        _c = method;
                        switch (_c) {
                            case 'GET': return [3 /*break*/, 3];
                            case 'POST': return [3 /*break*/, 5];
                            case 'PATCH': return [3 /*break*/, 7];
                            case 'PUT': return [3 /*break*/, 9];
                            case 'DELETE': return [3 /*break*/, 11];
                        }
                        return [3 /*break*/, 2];
                    case 2:
                        {
                            throw new Error("Unknown method ".concat(method));
                        }
                        _g.label = 3;
                    case 3: return [4 /*yield*/, axios.get(url, { params: params })];
                    case 4:
                        response = _g.sent();
                        return [3 /*break*/, 13];
                    case 5: return [4 /*yield*/, axios.post(url, payload, { params: params, headers: headers })];
                    case 6:
                        response = _g.sent();
                        return [3 /*break*/, 13];
                    case 7: return [4 /*yield*/, axios.patch(url, payload, { params: params })];
                    case 8:
                        response = _g.sent();
                        return [3 /*break*/, 13];
                    case 9: return [4 /*yield*/, axios.put(url, payload, { params: params })];
                    case 10:
                        response = _g.sent();
                        return [3 /*break*/, 13];
                    case 11: return [4 /*yield*/, axios.delete(url, { data: payload, params: params })];
                    case 12:
                        response = _g.sent();
                        return [3 /*break*/, 13];
                    case 13:
                        responseData = response.data;
                        keys = Object.keys(responseData);
                        if (keys.length === 1 && keys[0] === 'data')
                            return [2 /*return*/, responseData.data];
                        return [2 /*return*/, responseData];
                    case 14:
                        error_1 = _g.sent();
                        errorMessage = get(error_1, 'response.data');
                        isErrorString = typeof errorMessage === "string";
                        if (isInvalidZipCodeError(error_1, isErrorString, errorMessage))
                            return [2 /*return*/];
                        if (!isClientErrorInLocations(error_1))
                            captureException(error_1, {
                                abTest: this.abTest,
                                apiKey: this.apiKey,
                                baseUrl: this.baseUrl,
                                domain: this.domain,
                                method: method,
                                path: path,
                                payload: payload,
                                query: query,
                                // questionnaireId: this.questionnaireId,
                                response: response,
                                token: this.token,
                                url: url,
                                version: this.version
                            });
                        throw error_1;
                    case 15: return [2 /*return*/];
                }
            });
        });
    };
    API.prototype.postRequest = function (endpoint, data) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.request({
                        method: 'POST',
                        path: "/".concat(endpoint, "?apiKey=").concat(this.apiKey),
                        payload: data
                    })];
            });
        });
    };
    return API;
}());
export default API;
function isInvalidZipCodeError(error, isErrorString, errorMessage) {
    return (error.response &&
        error.response.status === 400 &&
        isErrorString &&
        errorMessage.includes('The zip code is invalid'));
}
function isClientErrorInLocations(error) {
    return (error.response &&
        error.response.status >= 400 &&
        error.response.status < 500 &&
        error.config.url.includes('locations'));
}
export var customPostRequest = function (url, data) { return __awaiter(void 0, void 0, Promise, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, axios({
                method: 'post',
                url: url,
                data: data
            })];
    });
}); };
